import React, { useEffect, useMemo, useState } from "react";
import Sidebar from "../components/Sidebar";
import "../css/dealer.css";
import "../css/records.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllStores } from "../actions/storeActions";
import NotAuthorized from "../components/NotAuthorized";

const StoresScreen = () => {
  const dispatch = useDispatch();

  const getStores = useSelector((state) => state.getStores);
  const { stores } = getStores;
  // let distinctStates = [...new Set(stores.map((store) => store.state))];
  useEffect(() => {
    dispatch(getAllStores());
  }, [dispatch]);
  const navigate = useNavigate();
  const [inputState, setInputState] = useState("All");
  const [nameQuery, setNameQuery] = useState("");

  const handleSelectChange = (e) => {
    setInputState(e.target.value);
  };

  // Derived from `stores` on every change instead of copied into its own
  // state, so the grid updates the instant data arrives (previously
  // `filteredStores` was seeded once via useState(stores) — before the
  // fetch resolved — and never re-synced, so the page looked stuck empty
  // until the search button was clicked).
  const filteredStores = useMemo(() => {
    if (!stores) return null;
    const query = nameQuery.trim().toLowerCase();
    return stores.filter((store) => {
      const matchesState =
        inputState === "All" || inputState === "" || store.state === inputState;
      const matchesName =
        !query || store.name?.toLowerCase().includes(query);
      return matchesState && matchesName;
    });
  }, [stores, inputState, nameQuery]);

  const adminInfo = useSelector((state) => state.adminInfo);

  const { adminData } = adminInfo;

  useEffect(() => {
    if (adminData) {
      if (adminData.accessLevel === "Viewer") {
        console.log("you're not allowed");
      }
    }
  }, []);

  return (
    <div className="container-fluid ">
      <div className="row ">
        <div className="col-lg-2 p-0">
          <Sidebar active={6} />
        </div>
        <div
          className="col-lg-10 p-0"
          style={{
            overflowY: "scroll",
            height: "100vh",
          }}
        >
          {adminData && adminData.accessLevel === "Viewer" ? (
            <NotAuthorized />
          ) : (
            <div className="records-page">
              <div className="records-header-row d-flex align-items-center justify-content-between flex-wrap">
                <h4 className="records-heading">Stores</h4>
              </div>

              <div className="records-toolbar">
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control"
                    id="store-name-search"
                    autoComplete="off"
                    value={nameQuery}
                    onChange={(e) => setNameQuery(e.target.value)}
                    placeholder="Dealer name"
                  />
                  <label for="store-name-search">Search Dealer Name</label>
                </div>
                <div class="form-floating">
                  <select
                    class="form-control"
                    id="floatingSelect"
                    aria-label="Floating label select example"
                    onChange={handleSelectChange}
                  >
                    <option selected value="All">
                      All
                    </option>
                    {stores &&
                      [...new Set(stores.map((store) => store.state))]
                        .sort()
                        .map((state, index) => (
                          <option key={index} value={state}>
                            {state}
                          </option>
                        ))}
                  </select>
                  <label for="floatingSelect" className="text-grey">
                    Select State
                  </label>
                </div>
                <button
                  className="btn btn-success text-light records-icon-btn"
                  title="Export"
                >
                  <i class="fa-solid fa-download"></i>
                </button>
                <Link to={"/add-store"}>
                  <button
                    className="btn btn-primary records-icon-btn"
                    title="Add store"
                  >
                    <i class="fa-solid fa-user-plus"></i>
                  </button>
                </Link>
              </div>

              <div className="stat-pills" style={{ marginBottom: "1em" }}>
                <span className="stat-pill total">
                  <span className="stat-dot"></span>Showing{" "}
                  <span className="stat-value">
                    {filteredStores && filteredStores.length}
                  </span>
                </span>
              </div>

              <div className="grid-container">
                {filteredStores &&
                  filteredStores.map((store) => (
                    <div key={store._id} className="store-card">
                      <div className="store-card-body">
                        <h5 className="store-card-title">{store.name}</h5>

                        <div className="store-card-row">
                          <i class="fa-solid fa-phone"></i>
                          <span>
                            {store.phoneNumber ? store.phoneNumber : "NA"}
                          </span>
                        </div>

                        <a
                          href={store.link}
                          className="text-decoration-none"
                          style={{ color: "inherit" }}
                        >
                          <div className="store-card-row">
                            <i class="fa-solid fa-location-dot"></i>
                            <span>
                              {store.city ? store.city : "NA"}, &nbsp;
                              {store.state ? store.state : "NA"}
                            </span>
                          </div>
                        </a>
                      </div>
                      <button
                        className="btn btn-primary records-action-btn store-card-edit"
                        onClick={() => navigate(`/store/${store._id}`)}
                      >
                        <i class="fa-solid fa-pen"></i> Edit
                      </button>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoresScreen;
